module.exports = __webpack_public_path__ + "img/save.1fbe1fa0.svg";